module.exports = __webpack_public_path__ + "static/img/p9.b13f090b.png";